import { colors } from '../styles/theme';

const DANGER = '#EE5757';
const TEXT_PRIMARY = '#F9FAFB';
const BORDER_CANCEL_BUTTON = '#E8F4F4';

/**
 * Contained primary del footer.
 * `busy`: deshabilitado por carga → mantiene color (sin gris oscuro).
 * Sin busy (p. ej. sin emails): disabled gris habitual.
 */
export function getSharePrimaryButtonSx({ busy = false } = {}) {
  return {
    textTransform: 'none',
    bgcolor: colors.primary,
    color: '#fff',
    fontSize: '13px',
    fontWeight: 600,
    height: 40,
    borderRadius: '8px',
    px: 2,
    boxShadow: 'none',
    '&:hover': { bgcolor: colors.primaryHover, boxShadow: 'none' },
    '&.Mui-disabled': busy
      ? {
          bgcolor: colors.primary,
          color: '#fff',
          opacity: 0.85,
          boxShadow: 'none',
        }
      : {
          bgcolor: '#4A4A4A',
          color: '#ABABAB',
          boxShadow: 'none',
        },
    '&.Mui-disabled .MuiButton-startIcon': busy
      ? { color: '#fff' }
      : { color: '#ABABAB' },
  };
}

/** Outlined danger (Desactivar enlace): al busy mantiene rojo, sin apagarse a gris. */
export function getShareDangerButtonSx({ busy = false } = {}) {
  return {
    textTransform: 'none',
    color: DANGER,
    borderColor: DANGER,
    fontSize: '13px',
    height: 40,
    borderRadius: '8px',
    '& .MuiButton-startIcon': { color: DANGER },
    '&:hover': {
      borderColor: DANGER,
      bgcolor: 'rgba(238,87,87,0.08)',
      color: DANGER,
    },
    '&.Mui-disabled': {
      color: DANGER,
      borderColor: DANGER,
      opacity: busy ? 0.85 : 0.7,
    },
    '&.Mui-disabled .MuiButton-startIcon': {
      color: DANGER,
    },
  };
}

/** Cancelar outlined: al busy mantiene aspecto, sin gris. */
export function getShareCancelButtonSx({ busy = false } = {}) {
  return {
    textTransform: 'none',
    color: TEXT_PRIMARY,
    borderColor: BORDER_CANCEL_BUTTON,
    borderRadius: '8px',
    height: 40,
    fontSize: '13px',
    '&:hover': {
      borderColor: 'rgba(255,255,255,0.28)',
      bgcolor: 'rgba(255,255,255,0.04)',
    },
    '&.Mui-disabled': busy
      ? {
          color: TEXT_PRIMARY,
          borderColor: BORDER_CANCEL_BUTTON,
          opacity: 0.85,
        }
      : undefined,
  };
}
